import React, { type FunctionComponent, Fragment } from 'react'
import styled from '@emotion/styled'
import { colors } from '@retailer-platform/shared-components'
import { AppContentContainer } from '../../gin-and-tonic/containers/app-content-container/AppContentContainer'
import ErrorBoundary from '../../legacy/components/ErrorBoundary'
import { type DashRouteComponentProps } from '../../legacy/dash-components/dash-route/utils/dashRoute.types'
import { Z_INDEX_THIRD } from '../../legacy/common/theme'
import { CurrentAccountProvider } from '../../utils/current-account/CurrentAccountProvider'
import { DevPortalNav } from '../../gin-and-tonic/containers/nav/DevPortalNav'
import { type PartnerScopedRouteParams } from '../../legacy/common/types'
import { useAdminControls } from '../../utils/contexts/admin-controls/AdminControlsContext'
import { ContactHeader } from '../../routes/utils/ContactHeader'
import { DevPortalSectionRoutes } from './DevPortalSectionRoutes'

interface Props extends DashRouteComponentProps<PartnerScopedRouteParams> {}

const DevPortalNavContainer = styled.aside({
  position: 'fixed',
  height: '100%',
  display: 'flex',
  width: '41px',
  top: 0,
  left: 0,
  zIndex: Z_INDEX_THIRD,
  borderRight: `1px solid ${colors.GRAYSCALE.X20}`,
})

export const DevPortalSection: FunctionComponent<Props> = ({ location: { pathname } }) => {
  const { showContactHeader } = useAdminControls()
  return (
    <Fragment>
      <CurrentAccountProvider>
        <DevPortalNavContainer>
          <DevPortalNav />
        </DevPortalNavContainer>

        <AppContentContainer>
          {showContactHeader && <ContactHeader />}
          <ErrorBoundary pathname={pathname}>
            <DevPortalSectionRoutes />
          </ErrorBoundary>
        </AppContentContainer>
      </CurrentAccountProvider>
    </Fragment>
  )
}
